module.exports = function resizeImage(url, width, height) {
  return "https://yec.co/resize?url=".concat(encodeURIComponent(url), "&width=").concat(width, "&height=").concat(height);
};